<template>
  <DescriptionSection>
    <DescriptionItem title="Dokumenty" :value="service.attachments.length.toString()"></DescriptionItem>
  </DescriptionSection>
</template>

<script>
import DescriptionSection from '@/component/Description/description-section';
import DescriptionItem from '@/component/Description/description-item';

export default {
  name: 'CargoCorrectionDetails',
  components: {
    DescriptionSection,
    DescriptionItem,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
